import React from "react";
import { Stepper, Step, StepLabel, StepContent } from "@material-ui/core";
import IStep from "../../models/IStep";
import fetchJson from "../../functions/fetchJson";
import Skeleton from "@material-ui/lab/Skeleton";
import getNumberArray from "../../functions/getNumberArray";

export interface IStepsProps {
  steps: IStep[];
}

const Steps = (props: IStepsProps) => {
  const { steps } = props;
  return (
    <Stepper orientation="vertical">
      {steps.map(step => (
        <Step active={true} key={step.label}>
          <StepLabel>{step.label}</StepLabel>
          <StepContent>{step.description}</StepContent>
        </Step>
      ))}
    </Stepper>
  );
};

export interface IStepsWithDataProps {
  path: string;
}

export default (props: IStepsWithDataProps) => {
  const { path } = props;
  const [content, setContent] = React.useState<IStep[] | undefined>();
  React.useEffect(fetchJson(path, setContent), []);

  return content ? (
    <Steps steps={content} />
  ) : (
    <>
      <Skeleton width="100%" height="60px" />
      {getNumberArray(6).map(num => (
        <div key={num}>
          <Skeleton key={num} width="25%" height="50px" />
          {getNumberArray(4).map(n => (
            <Skeleton key={n} width="100%" height="50px" />
          ))}
        </div>
      ))}
    </>
  );
};
